module.exports = __webpack_public_path__ + "96833b24011bce9de94610faccd28426.png";